module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Pencil-0ca15e8f63b35fccfc01c3f42b838474.svg";